<img style="height: 130px;" class="img-fluid" src="../../../assets/images/saiyarti_loader.gif" alt="">